import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  noticeData: [], // 공지사항 정보
  tbmMonthlyTime: 7200, // TBM 월간 이수 목표시간(초단위)
  tbmProgress: 0, // TBM 진행률 정보(초단위)
  waitingPaymentInfoWaitCnt: 0, // 결재 대기 총 건수 (하위 호환)
  waitingPaymentInfoLastTitle: '결재 대기 중인 문서가 없습니다.',
  permitWaitCnt: 0, // 작업허가서 대기 건수
  permitLastTitle: '결재 대기 중인 문서가 없습니다.',
  resumeWaitCnt: 0, // 작업재개 대기 건수
  resumeLastTitle: '결재 대기 중인 문서가 없습니다.',
  tbmManagerYn: false, // TBM 진행자 여부
  riskWorkerOpinionMenuActive: false, // 근로자 의견 메뉴 활성화 여부
};

const HomeInfoSlice = createSlice({
  name: 'HomeInfo',
  initialState,
  reducers: {
    setNoticeData(state, action) {
      state.noticeData = action.payload;
    },
    /** 공지 상세 조회 후 해당 건 newYn 제거 */
    markNoticeRead(state, action) {
      const chaebunNo = action.payload;
      if (!chaebunNo) return;
      state.noticeData = (state.noticeData || []).map((item) =>
        item.chaebunNo === chaebunNo ? { ...item, newYn: 'N' } : item
      );
    },
    setTbmProgress(state, action) {
      state.tbmProgress = action.payload;
    },
    setWaitingPaymentInfoWaitCnt(state, action) {
      state.waitingPaymentInfoWaitCnt = action.payload;
    },
    setWaitingPaymentInfoLastTitle(state, action) {
      state.waitingPaymentInfoLastTitle = action.payload;
    },
    setPermitWaitCnt(state, action) {
      state.permitWaitCnt = action.payload;
    },
    setPermitLastTitle(state, action) {
      state.permitLastTitle = action.payload;
    },
    setResumeWaitCnt(state, action) {
      state.resumeWaitCnt = action.payload;
    },
    setResumeLastTitle(state, action) {
      state.resumeLastTitle = action.payload;
    },
    setTbmManagerYn(state, action) {
      state.tbmManagerYn = action.payload;
    },
    setRiskWorkerOpinionMenuActive(state, action) {
      state.riskWorkerOpinionMenuActive = action.payload;
    },
  },
});

export const HomeInfoActions = HomeInfoSlice.actions;
export default HomeInfoSlice.reducer;
